module.exports = __webpack_public_path__ + "media/images/IMG1_features-4bf63660.png";